module.exports = __webpack_public_path__ + "stickerpack-placeholder.png?9c54c1300d9fc1449662224859a4bb69";